import { render, staticRenderFns } from "./RequestEntity.vue?vue&type=template&id=31229855&"
import script from "./RequestEntity.vue?vue&type=script&lang=js&"
export * from "./RequestEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports